import React, { useEffect, useState } from 'react'
import { getRouteInfo } from './utils'

export const useRouting = ({ setLoading, loadingTime, onNavigation }) => {
  const [routing, setRouting] = useState(getRouteInfo());
  const [url, setUrl] = useState(routing.url);
  const [baseUrl, setBaseUrl] = useState(routing.baseUrl);
  const [searchParams, setSearchParams] = useState(routing.searchParams);
  const [route, setRoute] = useState(routing.route);
  const [routes, setRoutes] = useState({});

  const navigate = (path, urlParams)=>{
    if (typeof path === "function"){
      let current = window.location.href.split('?')[0];
      if (current.slice(0, current.length - 1) === baseUrl){
        current = baseUrl;
      }
      
      path = path(current);
    }

    if (urlParams){
      path += '?';
      for (const [key, value] of Object.entries(urlParams)){
        path += `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      }
    }
    
    setTimeout(()=>{
      window.scrollTo({ top: 0, behavior: 'instant' });
    }, loadingTime / 2);
    
    history.pushState({}, '', path);
    onNavigation(window.location.href);
    window.dispatchEvent(new PopStateEvent('popstate'));
  }

  useEffect(() => {
    const listener = () =>{
      setLoading(true);
      const routing = getRouteInfo();
      setRoute(routing.route);

      setTimeout(()=>{
        setUrl(routing.url);
        setRouting(routing);
        setBaseUrl(routing.baseUrl);
        setSearchParams(routing.searchParams);

        setTimeout(()=>{
          setLoading(false);
        },loadingTime / 2);
      },loadingTime / 2);
    }

    window.addEventListener("popstate", listener);
    return () =>{
      window.removeEventListener("popstate", listener);
    }
  }, []);

  return {
    url, setUrl,
    baseUrl,
    searchParams,
    route,
    routes, setRoutes,
    navigate
  }
}
